import { useContext, useEffect, useState } from 'react';

import { AuthContext } from '../contexts/AuthContext.js';

export function useAccessToken() {
  const auth = useContext(AuthContext);
  const [token, setToken] = useState(auth.getAccessToken());
  useEffect(
    () => auth.subscribe(() => setToken(auth.getAccessToken())),
    [auth],
  );

  return token;
}
